import { FormField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface BasicInfoTabProps {
  formMode: FormMode;
}

const BasicInfoTab: React.FC<BasicInfoTabProps> = ({ formMode }) => {
  const isViewMode = formMode === 'view';

  return (
    <div className='max-h-[calc(100vh-150px)] overflow-y-auto'>
      <div className='space-y-2 p-4'>
        <div className='space-y-1'>
          {/* Mã khế ước */}
          <div className='flex items-center'>
            <Label className='w-40 min-w-40'>Mã khế ước</Label>
            <FormField type='text' name='ma_ku' className='w-64' disabled={isViewMode || formMode === 'edit'} />
          </div>
          {/* Tên khế ước */}
          <div className='flex items-center'>
            <Label className='w-40 min-w-40'>Tên khế ước</Label>
            <FormField type='text' name='ten_ku' className='w-96' disabled={isViewMode} />
          </div>
          {/* Tên khác */}
          <div className='flex items-center'>
            <Label className='w-40 min-w-40'>Tên khác</Label>
            <FormField type='text' name='ten_ku2' className='w-96' disabled={isViewMode} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicInfoTab;
